import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Header from "../components/Header";

function Register() {
    const [err, setErr] = useState(null);
    const login = localStorage.getItem("user");
    const [affiliate, setAffiliate] = useState(null);
    const navigate = useNavigate();
    const [profile, setProfile] = useState(null);
    
    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm();
    
    useEffect(() => {
        if (login) {
            navigate("/");
        } else {
            const urlParams = new URLSearchParams(window.location.search);
            const refParam = urlParams.get("ref");
            if (refParam) {
                setAffiliate(refParam);
            }
            if (localStorage.getItem("affiliate")) {
                setAffiliate(localStorage.getItem("affiliate"));
            }
        }
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);
    
    const onSubmit = (data, e) => {
        e.preventDefault();
        const phoneNumberPattern = /^(0\d{9,10})$/;
        const regex = /^[a-zA-Z0-9]+$/;
        
        if (data.username.length < 6) {
            setError("username", {
                type: "minLength",
                message: "Tên đăng nhập tối thiểu 6 kí tự"
            });
            return;
        }
        if (data.username.length > 12) {
            setError("username", {
                type: "minLength",
                message: "Tên đăng nhập tối đa 12 kí tự"
            });
            return;
        }
        if (!regex.test(data.username)) {
            setError("username", {
                type: "minLength",
                message: "Tên đăng nhập không chứa khoảng trắng và ký tự đặc biệt"
            });
            return;
        }
        if (data.password.length < 6) {
            setError("password", {
                type: "minLength",
                message: "Mật khẩu tối thiểu 6 kí tự"
            });
            return;
        }
        if (data.password !== data.ippassword) {
            setError("ippassword", {
                type: "minLength",
                message: "Hai mật khẩu không khớp"
            });
            return;
        }
        if (!data.name) {
            data.name = data.username;
        }
        if (!data.sdt) {
            setError("sdt", {
                type: "minLength",
                message: "Vui lòng nhập số điện thoại"
            });
            return;
        }
        if (!phoneNumberPattern.test(data.sdt)) {
            setError("sdt", {
                type: "minLength",
                message: "Định dạng số điện thoại không hợp lệ"
            });
            return;
        }
        if (data.paypwd.length < 6) {
            setError("paypwd", {
                type: "minLength",
                message: "Mật khẩu rút tiền tối thiểu 6 kí tự"
            });
            return;
        }
        
        let formData;
        if (affiliate == null) {
            formData = {
                username: data.username.toLowerCase(),
                password: data.password,
                code: data.code === "" ? "admin" : data.code,
                sdt: data.sdt,
                name: data.name,
                paypwd: data.paypwd
            };
        } else {
            formData = {
                username: data.username.toLowerCase(),
                password: data.password,
                code: affiliate,
                sdt: data.sdt,
                name: data.name,
                paypwd: data.paypwd
            };
        }
        
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/register`, formData)
            .then((res) => {
                swal({
                    title: "Thông báo",
                    text: "Đăng ký thành công",
                    icon: "success",
                    buttons: "OK"
                }).then(() =>
                    axios
                        .post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                            username: data.username.toLowerCase(),
                            password: data.password
                        })
                        .then((res) => {
                            swal({
                                title: "Thông báo",
                                text: "Đăng nhập thành công",
                                icon: "success",
                                buttons: "OK"
                            }).then(() => {
                                localStorage.removeItem("user");
                                localStorage.removeItem("profile");
                                localStorage.removeItem("data");
                                localStorage.setItem("user", res.data.data);
                                window.location.href = "/";
                            });
                        })
                );
            })
            .catch((err) => {
                setErr(err.response?.data?.message ? err.response?.data?.message : "Đã có lỗi xảy ra!");
            });
    };

    const [showPassword, setShowPassword] = useState(false);
    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };
    
    const [showPassword1, setShowPassword1] = useState(false);
    const toggleShowPassword1 = () => {
        setShowPassword1(!showPassword1);
    };
    
    const [showPassword2, setShowPassword2] = useState(false);
    const toggleShowPassword2 = () => {
        setShowPassword2(!showPassword2);
    };

    return (
        <>
            <Header profile={profile} />
            
            {/* CSS TÙY CHỈNH CHO TRANG REGISTER ĐỒNG BỘ VỚI LOGIN */}
            <style>{`
                .login-page-wrapper {
                    min-height: calc(100vh - 100px);
                    background-image: url(${require("../../image/register.jpg")});
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 40px 20px;
                    position: relative;
                }
                .login-page-wrapper::before {
                    content: '';
                    position: absolute;
                    top: 0; left: 0; width: 100%; height: 100%;
                    background: rgba(0, 0, 0, 0.65);
                    z-index: 1;
                }
                .login-card {
                    background: #ffffff;
                    width: 100%;
                    max-width: 450px;
                    border-radius: 12px;
                    box-shadow: 0 15px 40px rgba(0,0,0,0.5);
                    position: relative;
                    z-index: 2;
                    overflow: hidden;
                }
                .login-header {
                    background: linear-gradient(135deg, #d32f2f, #b71c1c);
                    color: #ffffff;
                    text-align: center;
                    padding: 25px 20px;
                }
                .login-header h1 {
                    margin: 0;
                    font-size: 26px;
                    font-weight: bold;
                    letter-spacing: 1px;
                }
                .login-body {
                    padding: 30px 40px;
                }
                .form-group-new {
                    margin-bottom: 20px;
                    position: relative;
                }
                .form-group-new input {
                    width: 100%;
                    padding: 14px 45px 14px 15px; 
                    border: 1px solid #ccc;
                    border-radius: 6px;
                    font-size: 15px;
                    outline: none;
                    transition: border-color 0.3s;
                    box-sizing: border-box;
                    background: #fcfcfc;
                }
                .form-group-new input:focus {
                    border-color: #d32f2f;
                    background: #fff;
                }
                .form-group-new input:read-only {
                    background: #e9ecef;
                    color: #666;
                    cursor: not-allowed;
                }
                .eye-icon {
                    position: absolute;
                    right: 28px;
                    top: 18px;
                    transform: translateY(-50%);
                    color: #777;
                    cursor: pointer;
                    transition: color 0.3s;
                }
                .eye-icon:hover {
                    color: #d32f2f;
                }
                .error-text {
                    color: #d32f2f;
                    font-size: 13px;
                    margin-top: 5px;
                    margin-bottom: 0;
                    font-style: italic;
                }
                .server-error {
                    background: #ffebee;
                    color: #d32f2f;
                    padding: 10px;
                    border-radius: 6px;
                    font-size: 14px;
                    text-align: center;
                    margin-bottom: 20px;
                    border: 1px solid #ffcdd2;
                }
                .btn-login-submit {
                    width: 100%;
                    padding: 15px;
                    background: #d32f2f;
                    color: #fff;
                    border: none;
                    border-radius: 6px;
                    font-size: 16px;
                    font-weight: bold;
                    text-transform: uppercase;
                    cursor: pointer;
                    transition: background 0.3s;
                    margin-top: 10px;
                }
                .btn-login-submit:hover {
                    background: #b71c1c;
                }
                .login-footer {
                    text-align: center;
                    margin-top: 25px;
                    font-size: 15px;
                    color: #555;
                }
                .login-footer a {
                    color: #d32f2f;
                    text-decoration: none;
                    font-weight: bold;
                    transition: color 0.3s;
                }
                .login-footer a:hover {
                    color: #b71c1c;
                    text-decoration: underline;
                }
                
                @media (max-width: 500px) {
                    .login-body {
                        padding: 25px 20px;
                    }
                }
            `}</style>

            <div className="login-page-wrapper">
                <div className="login-card">
                    <div className="login-header">
                        <h1>ĐĂNG KÝ</h1>
                    </div>
                    
                    <div className="login-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            {/* Khung báo lỗi từ Server */}
                            {err ? <div className="server-error">{err}</div> : null}

                            <div className="form-group-new">
                                <input type="text" {...register("username")} placeholder="Tên đăng nhập (6-12 ký tự)" />
                                {errors.username ? <p className="error-text">{errors.username.message}</p> : null}
                            </div>

                            <div className="form-group-new">
                                <input type={showPassword ? "text" : "password"} {...register("password")} placeholder="Mật khẩu (Tối thiểu 6 ký tự)" />
                                <div className="eye-icon" onClick={toggleShowPassword}>
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                </div>
                                {errors.password ? <p className="error-text">{errors.password.message}</p> : null}
                            </div>

                            <div className="form-group-new">
                                <input type={showPassword1 ? "text" : "password"} {...register("ippassword")} placeholder="Nhập lại mật khẩu" />
                                <div className="eye-icon" onClick={toggleShowPassword1}>
                                    {showPassword1 ? <Visibility /> : <VisibilityOff />}
                                </div>
                                {errors.ippassword ? <p className="error-text">{errors.ippassword.message}</p> : null}
                            </div>

                            <div className="form-group-new">
                                <input type="tel" {...register("sdt")} placeholder="Số điện thoại" />
                                {errors.sdt ? <p className="error-text">{errors.sdt.message}</p> : null}
                            </div>

                            <div className="form-group-new">
                                <input type={showPassword2 ? "text" : "password"} {...register("paypwd")} placeholder="Mật khẩu rút tiền (Tối thiểu 6 ký tự)" />
                                <div className="eye-icon" onClick={toggleShowPassword2}>
                                    {showPassword2 ? <Visibility /> : <VisibilityOff />}
                                </div>
                                {errors.paypwd ? <p className="error-text">{errors.paypwd.message}</p> : null}
                            </div>

                            <div className="form-group-new">
                                {affiliate == null ? (
                                    <input type="text" {...register("code")} placeholder="Mã mời (nếu có)" />
                                ) : (
                                    <input type="text" {...register("code")} placeholder="Mã mời (nếu có)" defaultValue={affiliate} readOnly />
                                )}
                                {errors.code ? <p className="error-text">{errors.code.message}</p> : null}
                            </div>

                            <button className="btn-login-submit" type="submit">
                                Đăng ký ngay
                            </button>
                        </form>

                        <div className="login-footer">
                            Bạn đã có tài khoản? <Link to="/login">Đăng nhập tại đây</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Register;